<template>
  <div class="d-flex flex-column mt-5">
    <h4 :style="testProductDetail ? 'font-size: 20px !important;' : 'font-size: 26px;'" class="me-2 mb-2 mb-md-0">
      <span class="text-red">{{ testProductDetail ? 'Stap 3/3' : 'Stap 4/4' }}</span> - WAAR NAARTOE
    </h4>
    <div
      :class="['d-flex', 'mt-4', 'flex-column', 'rounded-4', 'form-container-wrapper', testProductDetail ? 'p-4-5' : 'p-0 p-lg-5 shadow-none shadow-lg-sm']">
      <h4 class="fw-medium" :style="testProductDetail ? 'font-size: 18px !important;' : `font-size: 20px;`">WANNEER MAG
        HET VERZONDEN WORDEN?</h4>
      <p class="text-grey">Let op, je kiest een datum waarop bij ons het pakketje de deur uit gaat.</p>

      <!-- Add ref for scrolling to date picker -->
      <div ref="datePickerRef">
        <DatePicker v-model="selectedDate" :min-date="minSelectableDate" :disabled-dates="disabledDates" format="dd-MM-yyyy"
          :enable-time="false" locale="nl" auto-apply input-class-name="flatpickr-input mt-3 mb-2"
          placeholder="Selecteer datum" @update:model-value="handleDateSelect" />
        <span class="mt-0 text-danger">{{ getErrorMessage('date') }}</span>
      </div>

      <h4 class="fw-medium mt-4 pb-0 mb-0"
        :style="testProductDetail ? 'font-size: 18px !important;' : `font-size: 20px;`">GEGEVENS ONTVANGER</h4>

      <!-- NAAM Input -->
      <label class="sd-label-pb">NAAM*</label>
      <input class="rounded-3 px-3" v-model="receiver.name" :class="{ 'border-danger': hasError('name') }"
        placeholder="Naam" />
      <span class=" text-danger">{{ getErrorMessage('name') }}</span>

      <!-- LAND Input -->
      <label class="sd-label-pb">LAND*</label>
      <select class="rounded-3 px-3" v-model="receiver.country" readonly>
        <option value="Nederland">Nederland</option>
        <option value="Belgie">Belgie</option>
        <option value="Duitsland">Duitsland</option>
      </select>


      <!-- POSTCODE Input -->
      <label class="sd-label-pb">POSTCODE*</label>
      <input class="rounded-3 px-3" v-model="receiver.zipcode" :class="{ 'border-danger': hasError('zipcode') }"
        placeholder="Postcode" />
      <span class="text-danger">{{ getErrorMessage('zipcode') }}</span>

      <div class="row">
        <!-- HUISNR.* Input -->
        <div class="col-md-6 mb-0">
          <label class="sd-label-pb">HUISNR.*</label>
          <input class="rounded-3 px-3 w-100" v-model="receiver.number" :class="{ 'border-danger': hasError('number') }"
            placeholder="Nr." />
          <span class="text-danger">{{ getErrorMessage('number') }}</span>
        </div>
        <!-- TOEV. Input -->
        <div class="col-md-6 mb-0">
          <label class="sd-label-pb">TOEV.</label>
          <input class="rounded-3 px-3 w-100" v-model="receiver.addition" placeholder="Toev." />
        </div>
      </div>

      <!-- Address Warning Alert -->
      <div v-if="showAddressWarning" class="alert alert-warning mt-3 d-flex align-items-center" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-exclamation-triangle-fill me-2" viewBox="0 0 16 16">
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg>
        <span class="ms-1">We konden je straat en plaatsnaam niet vinden, weet je zeker dat het adres juist is ingevoerd?</span>
      </div>

      <!-- STRAAT Input -->
      <label class="sd-label-pb">STRAAT*</label>
      <input class="rounded-3 px-3" v-model="receiver.street" :class="{ 'border-danger': hasError('street') }"
        placeholder="Straat" />
      <span class="text-danger">{{ getErrorMessage('street') }}</span>

      <!-- PLAATS Input -->
      <label class="sd-label-pb">PLAATS*</label>
      <input class="rounded-3 px-3" v-model="receiver.city" :class="{ 'border-danger': hasError('city') }"
        placeholder="Plaats" />
      <span class="text-danger">{{ getErrorMessage('city') }}</span>

      <div class="d-flex mt-4 align-items-center justify-content-end gap-3">
        <button class="bg-red fs-15 text-light py-3 px-5 border-0 rounded-pill" @click="handleAddBox">
          {{ testProductDetail ? 'Toevoegen aan winkelwagen' : 'Toevoegen' }}
        </button>
        <Popup :show="openPopup" :boxdata="popupData" @close="openPopup = false" @add-new-box="handleAddAnotherBox"
          @add-same-box="handleAddBoxWithoutReset" @checkout="handleCheckout" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount, defineProps, defineEmits, computed } from 'vue';
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import 'bootstrap/dist/css/bootstrap.css';
import woocommerceService from '@/woocommerceService';
import { validateSelection } from '../utils/validateSelection.js';
import Popup from '@/components/popup-component.vue';

const props = defineProps(['boxdata', 'testProductDetail', 'activeBox']);
const emit = defineEmits(['addresschange', 'another-box', 'checkout']);

const receiver = ref({
  name: '',
  country: 'Nederland',
  zipcode: '',
  number: '',
  addition: '',
  street: '',
  city: '',
});
const errors = ref([]);
const selectedDate = ref(null);
const excludedDates = ref([]);
const excludedDays = ref([]);
const openPopup = ref(false);
const popupData = ref({});
const showAddressWarning = ref(false);
const datePickerRef = ref(null);

const minSelectableDate = computed(() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
});


const dayMap = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

const isSameDay = (firstDate, secondDate) => {
  if (!(firstDate instanceof Date) || !(secondDate instanceof Date)) {
    return false;
  }

  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  );
};

const isWithinSpecialPeriod = computed(() => {
  return (date) => {
    if (!props.boxdata?.pickedBox?.product_options?.speciale_omlooptijd?.enabled) {
      return true;
    }

    const { start, end } = props.boxdata.pickedBox.product_options.speciale_omlooptijd;
    if (!start || !end) return true;

    const startDate = new Date(start);
    const endDate = new Date(end);
    
    endDate.setDate(endDate.getDate());

    const checkDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return checkDate >= startDate && checkDate < endDate;
  };
});

const disabledDates = computed(() => {
  if (!Array.isArray(excludedDates.value) || !Array.isArray(excludedDays.value)) {
    return [];
  }

  const dates = [];
  const today = new Date();
  const oneYearFromNow = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());

  const specificDates = excludedDates.value
    .filter(date => date instanceof Date)
    .map(date => new Date(date.getFullYear(), date.getMonth(), date.getDate()));

  let current = new Date(today);
  while (current <= oneYearFromNow) {
    if (!isWithinSpecialPeriod.value(current) || excludedDays.value.includes(current.getDay())) {
      dates.push(new Date(current.getFullYear(), current.getMonth(), current.getDate()));
    }
    current.setDate(current.getDate() + 1);
  }

  const now = new Date();
  if (now.getHours() >= 14) {
    dates.push(new Date(now.getFullYear(), now.getMonth(), now.getDate()));
  }

  return [...specificDates, ...dates];
});

function handleDateSelect(newDate) {
  try {
    const now = new Date();
    if (newDate) {
      const dateOnly = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
      const isToday = isSameDay(dateOnly, now);
      
      if (!isWithinSpecialPeriod.value(dateOnly)) {
        selectedDate.value = null;
        errors.value.push({ 
          type: 'date', 
          message: 'Deze box is alleen beschikbaar binnen de aangegeven periode.' 
        });
        return;
      }

      if (!(isToday && isAfterTwoPM.value)) {
        selectedDate.value = dateOnly;
        errors.value = errors.value.filter(err => err.type !== 'date');
        emit('datechange', dateOnly);
      } else {
        selectedDate.value = null;
        errors.value.push({ 
          type: 'date', 
          message: 'Bestellen na 14:00 uur voor vandaag is niet mogelijk.' 
        });
      }
    }
  } catch (error) {
    console.error('Error selecting date:', error);
    selectedDate.value = null;
    errors.value.push({ 
      type: 'date', 
      message: 'Er is een fout opgetreden bij het selecteren van de datum.' 
    });
  }
}

const isAfterTwoPM = computed(() => {
  const now = new Date();
  return now.getHours() >= 14;
});

const normalizeZipcode = (value) => (value ? value.toUpperCase().replace(/[^0-9A-Z]/g, '') : '');
const normalizeNumber = (value) => (value != null ? String(value).trim() : '');
const normalizeAddition = (value) => (value ? String(value).trim().toUpperCase() : '');

const zipcodeValidationRules = {
  Nederland: {
    pattern: /^[1-9]\d{3}(?:\s?[A-Z]{2})?$/,
    message: 'Postcode is ongeldig. Gebruik het formaat 1234 AB.',
  },
  Belgie: {
    pattern: /^[1-9]\d{3}$/,
    message: 'Postcode is ongeldig. Gebruik 4 cijfers voor Belgische adressen.',
  },
  Duitsland: {
    pattern: /^\d{5}$/,
    message: 'Postcode is ongeldig. Gebruik 5 cijfers voor Duitse adressen.',
  },
  default: {
    pattern: /^[A-Z0-9 -]{3,10}$/,
    message: 'Postcode is ongeldig.',
  },
};

const getZipcodeRule = (country) => zipcodeValidationRules[country] || zipcodeValidationRules.default;

let geocodeTimeoutId = null;
let activeGeocodeRequestToken = 0;

watch(
  () => [receiver.value.zipcode, receiver.value.number, receiver.value.addition],
  ([newZipcode, newNumber, newAddition], [oldZipcode, oldNumber, oldAddition] = []) => {
    const normalizedNewZip = normalizeZipcode(newZipcode);
    const normalizedOldZip = normalizeZipcode(oldZipcode);
    const normalizedNewNumber = normalizeNumber(newNumber);
    const normalizedOldNumber = normalizeNumber(oldNumber);
    const normalizedNewAddition = normalizeAddition(newAddition);
    const normalizedOldAddition = normalizeAddition(oldAddition);

    if (!normalizedNewZip || !normalizedNewNumber) {
      if (geocodeTimeoutId) {
        clearTimeout(geocodeTimeoutId);
        geocodeTimeoutId = null;
      }
      receiver.value.street = '';
      receiver.value.city = '';
      showAddressWarning.value = false;
      return;
    }

    if (
      normalizedNewZip === normalizedOldZip &&
      normalizedNewNumber === normalizedOldNumber &&
      normalizedNewAddition === normalizedOldAddition
    ) {
      return;
    }

    if (geocodeTimeoutId) {
      clearTimeout(geocodeTimeoutId);
    }

    geocodeTimeoutId = setTimeout(() => {
      geocodeTimeoutId = null;
      getStreetAndCityValue();
    }, 400);
  },
  { immediate: false }
);

// Watch for manual changes to street and city fields to hide warning
watch(
  () => [receiver.value.street, receiver.value.city],
  () => {
    // Hide warning when user manually enters street or city
    if (receiver.value.street || receiver.value.city) {
      showAddressWarning.value = false;
    }
  },
  { deep: true }
);

onMounted(() => {
  receiver.value = props.boxdata.receiver;
  emitAddressChange();
  getExcludedDateData();
});

onBeforeUnmount(() => {
  if (geocodeTimeoutId) {
    clearTimeout(geocodeTimeoutId);
    geocodeTimeoutId = null;
  }
});


async function getExcludedDateData() {
  try {
    const response = await fetch('https://sweetdeliver.nl/wp-json/verzenddata/v1/list');
    const res = await response.json();

    if (res && Array.isArray(res) && res.length > 0) {
      const data = res[0];

      if (data?.excluded_dates) {
        excludedDates.value = data.excluded_dates.split(',')
          .map((date) => {
            try {
              const [day, month, year] = date.trim().split('-');
              const parsedDate = new Date(`${year}-${month}-${day}`);
              return isNaN(parsedDate.getTime()) ? null : parsedDate;
            } catch (e) {
              console.error('Error parsing date:', date);
              return null;
            }
          })
          .filter(date => date !== null);
      }

      if (data?.excluded_days && Array.isArray(data.excluded_days)) {
        excludedDays.value = data.excluded_days
          .map(day => dayMap[day.toLowerCase()])
          .filter(day => typeof day === 'number');
      }
    }
  } catch (error) {
    console.error('Error fetching excluded dates:', error);
    excludedDates.value = [];
    excludedDays.value = [];
  }
}

async function getStreetAndCityValue() {
  try {
    if (receiver.value.country !== 'Nederland') {
      showAddressWarning.value = false;
      return;
    }

    const requestToken = ++activeGeocodeRequestToken;
    const normalizedZipcode = normalizeZipcode(receiver.value.zipcode);
    const houseNumber = normalizeNumber(receiver.value.number);
    const addition = normalizeAddition(receiver.value.addition);

    if (!/^\d{4}[A-Z]{2}$/.test(normalizedZipcode) || !houseNumber) {
      receiver.value.city = '';
      receiver.value.street = '';
      showAddressWarning.value = false;
      return;
    }

    const formattedZipcode = normalizedZipcode.replace(/^(\d{4})([A-Z]{2})$/, '$1 $2');
    const houseNumberWithAddition = addition ? `${houseNumber}${addition}` : houseNumber;
    const apiKey = 'AIzaSyDpKeZ5igxUPm83MCHg1-E9GMgyTEBrILg';

    const fetchGeocode = async (houseToken) => {
      const params = new URLSearchParams({
        address: `${houseToken} ${formattedZipcode} Netherlands`.trim(),
        key: apiKey,
        region: 'nl',
      });
      params.append('components', `postal_code:${normalizedZipcode}|country:NL`);
      const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?${params.toString()}`);
      return response.json();
    };

    const fetchReverseGeocode = async (lat, lng) => {
      const params = new URLSearchParams({
        latlng: `${lat},${lng}`,
        key: apiKey,
        region: 'nl',
      });
      params.append('result_type', 'street_address|premise|route');
      const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?${params.toString()}`);
      return response.json();
    };

    let res = await fetchGeocode(houseNumberWithAddition);
    let result = res.status === 'OK' && Array.isArray(res.results) ? res.results[0] : null;

    if (!result && addition) {
      res = await fetchGeocode(houseNumber);
      result = res.status === 'OK' && Array.isArray(res.results) ? res.results[0] : null;
    }

    if (requestToken !== activeGeocodeRequestToken) {
      return;
    }

    if (result) {
      const addressComponents = result.address_components || [];
      const findComponent = (types) =>
        addressComponents.find((component) => types.some((type) => component.types.includes(type)));

      const cityComponent =
        findComponent(['locality', 'postal_town', 'administrative_area_level_2']) ||
        findComponent(['administrative_area_level_1']);

      let streetComponent = findComponent(['route', 'street_address', 'premise', 'subpremise']);
      let street = streetComponent?.long_name || '';
      let city = cityComponent?.long_name || '';

      if (!street && result.formatted_address) {
        const firstSegment = result.formatted_address.split(',')[0] || '';
        const streetMatch = firstSegment.match(/^(.+?)\s+\d+[A-Z-]*$/i);
        if (streetMatch && streetMatch[1]) {
          street = streetMatch[1].trim();
        }
      }

      if (!street && result.geometry?.location) {
        const { lat, lng } = result.geometry.location;
        if (lat != null && lng != null) {
          const reverseRes = await fetchReverseGeocode(lat, lng);
          if (requestToken !== activeGeocodeRequestToken) {
            return;
          }
          if (reverseRes.status === 'OK' && Array.isArray(reverseRes.results) && reverseRes.results.length) {
            const reverseResult = reverseRes.results.find((item) =>
              (item.types || []).some((type) => ['street_address', 'premise', 'route'].includes(type))
            ) || reverseRes.results[0];

            if (reverseResult) {
              const reverseComponents = reverseResult.address_components || [];
              const reverseStreetComponent = reverseComponents.find((component) =>
                component.types.includes('route')
              );
              const reverseCityComponent =
                reverseComponents.find((component) => component.types.includes('locality')) ||
                reverseComponents.find((component) => component.types.includes('postal_town')) ||
                reverseComponents.find((component) => component.types.includes('administrative_area_level_2'));

              if (reverseStreetComponent?.long_name) {
                street = reverseStreetComponent.long_name;
              }

              if (!city && reverseCityComponent?.long_name) {
                city = reverseCityComponent.long_name;
              }
            }
          }
        }
      }

      receiver.value.city = city;
      receiver.value.street = street;
      showAddressWarning.value = !(receiver.value.city || receiver.value.street);
    } else {
      receiver.value.city = '';
      receiver.value.street = '';
      showAddressWarning.value = true; // Show warning when address not found
    }
  } catch (error) {
    console.error('Error fetching street and city:', error);
    // Show warning on API error as well
    showAddressWarning.value = true;
  }
}

function getErrorMessage(type) {
  const error = errors.value.find((err) => err.type === type);
  return error ? error.message : '';
}

function hasError(type) {
  return errors.value.some((err) => err.type === type);
}

function scrollToDatePicker() {
  if (datePickerRef.value) {
    datePickerRef.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function validate() {
  errors.value = []; // Reset errors
  let firstErrorField = null;

  // Validate Date first (since it's at the top of the form)
  if (!selectedDate.value) {
    errors.value.push({ type: 'date', message: 'Selecteer een verzenddatum.' });
    if (!firstErrorField) firstErrorField = 'date';
  }

  // Validate Name
  if (!receiver.value.name.trim()) {
    errors.value.push({ type: 'name', message: 'Naam is verplicht.' });
    if (!firstErrorField) firstErrorField = 'name';
  }

  // Validate Zipcode
  const normalizedZipcode = receiver.value.zipcode.trim().toUpperCase();
  const { pattern: zipcodePattern, message: zipcodeErrorMessage } = getZipcodeRule(receiver.value.country);
  
  if (!receiver.value.zipcode.trim()) {
    errors.value.push({ type: 'zipcode', message: 'Postcode is verplicht.' });
    if (!firstErrorField) firstErrorField = 'zipcode';
  } else if (!zipcodePattern.test(normalizedZipcode)) {
    errors.value.push({ type: 'zipcode', message: zipcodeErrorMessage });
    if (!firstErrorField) firstErrorField = 'zipcode';
  }

  // Validate House Number
  if (!receiver.value.number.trim()) {
    errors.value.push({ type: 'number', message: 'Huisnummer is verplicht.' });
    if (!firstErrorField) firstErrorField = 'number';
  }

  // Validate Street
  if (!receiver.value.street.trim()) {
    errors.value.push({ type: 'street', message: 'Straatnaam is verplicht.' });
    if (!firstErrorField) firstErrorField = 'street';
  }

  // Validate City
  if (!receiver.value.city.trim()) {
    errors.value.push({ type: 'city', message: 'Plaats is verplicht.' });
    if (!firstErrorField) firstErrorField = 'city';
  }

  // Scroll to first error field if validation fails
  if (firstErrorField === 'date') {
    scrollToDatePicker();
  }

  return errors.value.length === 0;
}



async function handleAddAnotherBox() {

  const { isValid: flavorIsValid, flavorError, cardError } = validateSelection(
    props.boxdata.flavours,
    props.boxdata.pickedBox?.product_options?.aantal_smaken,
    props.boxdata.wantCard,
    props.boxdata.selectedCard
  );

  if (!flavorIsValid || cardError.value) {
    if (flavorError.value) {
      const flavorElement = document.getElementById('select-flavors');
      if (flavorElement) {
        flavorElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (cardError.value) {
      const cardElement = document.querySelector('.flavor-danger');
      if (cardElement) {
        cardElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    return;
  }

  if (validate() || props.testProductDetail) {
    if (props.testProductDetail) {
      try {
        const cartItem = {
          product_id: props.activeBox.id,
          quantity: 1,
          verzenddatum: selectedDate.value.toISOString().split('T')[0],
          delivery_address: {
            name: receiver.value.name,
            address_1: `${receiver.value.street} ${receiver.value.number}`,
            address_2: receiver.value.addition,
            city: receiver.value.city,
            postcode: receiver.value.zipcode,
            country: receiver.value.country,
          },
          smaken: props.activeBox?.product_options?.smaken?.map((flavour) => flavour.name),
          card: props.boxdata.card.id
            ? {
              id: props.boxdata.card.id,
              'kaart-tekst': props.boxdata.card.text,
              'kaart-naam': props.boxdata.card.name,
              'kaart-ontvanger': receiver.value.name,
            }
            : null,
        };

        const response = await woocommerceService.addToCart([cartItem]);
        if (response.success) {
          window.location.href = '/winkelwagen/';
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    } else {
      emit('another-box', {
        ...props.boxdata,
        receiver: { ...receiver.value },
        sendDate: selectedDate.value.toISOString().split('T')[0],
        selectedCard: props.boxdata.selectedCard,
        card: props.boxdata.card
      });
      openPopup.value = true;
      popupData.value = {
        ...props.boxdata,
        pickedBox: props.boxdata.pickedBox
      };

      resetForm();
    }
  }
}

async function handleAddBox() {
  if (props.testProductDetail) {
    // Check if date is selected for test products
    if (!selectedDate.value) {
      errors.value.push({ type: 'date', message: 'Selecteer een verzenddatum.' });
      scrollToDatePicker();
      return;
    }
    
    try {
      // For test product detail, directly add to cart without full validation
      const cartItem = {
        product_id: props.activeBox.id,
        quantity: 1,
        verzenddatum: selectedDate.value.toISOString().split('T')[0],
        delivery_address: {
          name: receiver.value.name,
          address_1: `${receiver.value.street} ${receiver.value.number}`,
          address_2: receiver.value.addition,
          city: receiver.value.city,
          postcode: receiver.value.zipcode,
          country: receiver.value.country,
        },
        smaken: props.activeBox?.product_options?.smaken?.map((flavour) => flavour.name),
        card: props.boxdata.card.id
          ? {
            id: props.boxdata.card.id,
            'kaart-tekst': props.boxdata.card.text,
            'kaart-naam': props.boxdata.card.name,
            'kaart-ontvanger': receiver.value.name,
          }
          : null,
      };

      const response = await woocommerceService.addToCart([cartItem]);
      if (response.success) {
        window.location.href = '/winkelwagen/';
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
    return;
  }

  // Original validation and logic for non-test products
  const { isValid: flavorIsValid, flavorError, cardError } = validateSelection(
    props.boxdata.flavours,
    props.boxdata.pickedBox?.product_options?.aantal_smaken,
    props.boxdata.wantCard,
    props.boxdata.selectedCard
  );

  if (!flavorIsValid || cardError.value) {
    if (flavorError.value) {
      const flavorElement = document.getElementById('select-flavors');
      if (flavorElement) {
        flavorElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (cardError.value) {
      const cardElement = document.querySelector('.flavor-danger');
      if (cardElement) {
        cardElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    return;
  }

  if (validate()) {
    popupData.value = {
      ...props.boxdata,
      pickedBox: props.boxdata.pickedBox,
      receiver: { ...receiver.value },
      sendDate: selectedDate.value.toISOString().split('T')[0],
    };
    openPopup.value = true;
  }
}

async function handleAddBoxWithoutReset() {
  emit('another-box', {
    ...props.boxdata,
    receiver: { ...receiver.value },
    sendDate: selectedDate.value.toISOString().split('T')[0],
    selectedCard: props.boxdata.selectedCard,
    card: props.boxdata.card
  }, false);
  resetForm();
}

watch(
  () => props.boxdata.receiver,
  (newReceiver) => {
    receiver.value = newReceiver;
    emitAddressChange();
  },
  { deep: true }
);

function emitAddressChange() {
  emit('addresschange', receiver.value);
}

function handleCheckout() {
  handleAddAnotherBox();
  emit('checkout');
}


function resetForm() {
  receiver.value = {
    name: '',
    country: 'Nederland',
    zipcode: '',
    number: '',
    addition: '',
    street: '',
    city: '',
  };
  selectedDate.value = null;
  errors.value = [];
  showAddressWarning.value = false;
}
</script>

<style scoped>
input {
  padding: 12px;
  background-color: #fcfafa;
  border: 0.2px solid #162e87;
  outline: none;
  border-radius: 3px;
}

select {
  padding: 12px;
  background-color: #fcfafa;
  border: 0.2px solid #162e87;
  outline: none;
  border-radius: 3px;
}

.text-danger {
  color: red;
}

.border-danger {
  border-color: red !important;
}

.flatpickr-input {
  padding: 7px 12px;
  background-color: #fcfafa;
  border: 0.2px solid #162e87;
  outline: none;
  border-radius: 10px;
}

.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
}

.alert-warning svg {
  flex-shrink: 0;
}

:deep(.dp__input) {
  padding: 12px;
  background-color: #fcfafa;
  border: 0.2px solid #162e87;
  outline: none;
  border-radius: 3px;
  height: 49px;
}

:deep(.dp__input_icon) {
  right: 10px;
}

:deep(.dp__overlay) {
  z-index: 10000;
}

:deep(.dp__active_date) {
  background-color: rgba(255, 74, 74, 1) !important;
  color: white !important;
}

:deep(.dp__today) {
  border-color: rgba(255, 74, 74, 1) !important;
}

:deep(.dp__arrow_bottom) {
  border-top: 2px solid rgba(255, 74, 74, 1) !important;
  border-right: 2px solid rgba(255, 74, 74, 1) !important;
}

.form-container-wrapper {
  background-color: white;
}

:deep(.dp__input_wrap input) {
  border-radius: 10px;
  padding-left: 36px !important;
}

:deep(.dp__input_wrap div svg) {
  margin-top: 4px;
}

@media (max-width: 1000px) {
  .form-container-wrapper {
    background-color: transparent;
    padding: 0px;
  }
}

.sd-label-pb {
  padding: 1.2rem 0 .6rem 0;
  font-family: DMSans-Regular !important;
}
</style>
